import WizardPage from './wizard-page';
export default WizardPage;